var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 54,
    width: 246,
    height: 363,
    rx: 31,
    fill: "#231942"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.167 417V62.8333H166.5V417H104V42H333.167C349.743 42 365.64 48.5848 377.361 60.3058C389.082 72.0268 395.667 87.924 395.667 104.5V354.5C395.667 371.076 389.082 386.973 377.361 398.694C365.64 410.415 349.743 417 333.167 417H208.167ZM229 125.333V167H333.167V125.333H229ZM229 187.833V229.5H333.167V187.833H229ZM166.5 417H208.167V458.667H166.5V417Z",
    fill: "#f0fff1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.0f3a636da51e6d2f4a47539537ac42da.svg";
export { ForwardRef as ReactComponent };